// @flow

import { get, postDownload } from '../utils/api';

// The editable Form RD 3560-10 ("Customize 3560-10 Report" on Forecast Rents).
// Both endpoints are tenant-scoped under `/{organizationId}/{propertyId}/`.
// The response shape is frozen in fortress-backend
// __tests__/fixtures/rd-3560-10/greentree-form.json (copied beside the modal).
export default class Rd356010FormService {
  // Loads Intacct for the current-year period and the same dates a year
  // earlier. Dates are YYYY-MM-DD.
  getForm(
    organizationId: string,
    propertyId: string,
    currentYear: { beginDate: string, endDate: string },
    options?: Object,
  ) {
    return get(
      `/${organizationId}/${propertyId}/rd-3560-10` +
        `?currentYearBeginDate=${currentYear.beginDate}` +
        `&currentYearEndDate=${currentYear.endDate}`,
      options,
    );
  }

  // Resolves once the browser has saved the zip. The backend's
  // Content-Disposition filename wins over `fileName`. postDownload resolves a
  // JSON body (a 403 or 404 error) instead of rejecting, so anything that is
  // not the downloaded file is rejected here.
  generate(
    organizationId: string,
    propertyId: string,
    form: Object,
    fileName: string,
    options?: Object,
  ) {
    return postDownload(
      `/${organizationId}/${propertyId}/rd-3560-10/generate`,
      fileName,
      JSON.stringify(form),
      options,
    ).then((result) =>
      result instanceof Blob ? result : Promise.reject(result),
    );
  }
}
